import axios from "../axios-auth";
import orginal_axios from "axios";

export const accountTypeService = {
  getAccountTypeList,
  getAccountTypeDetail,
  saveAccountType,
  getAccountTypeByStatus,
  getAccountTypeExcelExport,
  getAllAccountTypeList,
};

function getAccountTypeList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.nature) {
    params["nature"] = searchParams.nature;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  return axios.get("/auth/all-account-type", { params });
}

function getAccountTypeDetail(id) {
  return axios.get("/auth/account-type/" + id);
}

function saveAccountType(accountType) {
  if (!accountType.id) {
    // new brand
    return axios.post("/auth/account-type", accountType);
  } else {
    // edit
    return axios.put("/auth/account-type", accountType);
  }
}

function getAccountTypeByStatus(status) {
  return axios.get("/auth/account-type-status/" + status);
}

function getAccountTypeExcelExport(searchParams) {
  let params = {};

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }

  if (searchParams.nature) {
    params["nature"] = searchParams.nature;
  }

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/account-type-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getAllAccountTypeList(searchParams) {
  let params = {};

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }

  if (searchParams.nature) {
    params["nature"] = searchParams.nature;
  }

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  return axios.get("/auth/print-account-types", { params });
}